



































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import DepositCardSettings from '@/models/Products/ProductSettings/DefaultSettings/Cards/DepositCardSettings';
import DepositCardSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/Cards/DepositCardSettingsEditDialog.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'DepositCardSettingsRead', components: { ProductState, DepositCardSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: DepositCardSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }
}
